import { render, staticRenderFns } from "./AudioPlayback.vue?vue&type=template&id=5a8e9c74&scoped=true&"
import script from "./AudioPlayback.vue?vue&type=script&lang=ts&"
export * from "./AudioPlayback.vue?vue&type=script&lang=ts&"
import style0 from "./AudioPlayback.vue?vue&type=style&index=0&id=5a8e9c74&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8e9c74",
  null
  
)

export default component.exports